import { Navigate, Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { useUser } from 'context/userContext';

function Layout() {
  const { company, companyLoading } = useUser();

  if (!companyLoading && (!company || !company?.active)) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-primary-600">
      <div className="flex-grow pt-10">
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </div>
      <footer className="bg-primary-600">
        <div className="w-full max-w-screen-xl p-4 mx-auto">
          <span className="block text-center text-white text-md dark:text-gray-400">© 2025 Teamfit. All Rights Reserved.</span>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
